import CTAButton from '../general/CTAButton';
import s from '../../styles/components/home/FinalCta.module.css';

export default function FinalCta({ data }) {
  const { label, headline, subhead, incentive, image, imageAlt, cta } = data;

  return (
    <section className={s.container}>
      <div className={s.mediaCol}>
        <img src={image} alt={imageAlt || ''} className={s.image} />
      </div>

      <div className={s.textCol}>
        {label && <p className={s.label}>{label}</p>}
        <h2 className={s.headline}>{headline}</h2>
        {subhead && <p className={s.subhead}>{subhead}</p>}
        <div className={s.ctaRow}>
          <CTAButton label={cta.label} url={cta.url} />
        </div>
      </div>
    </section>
  );
}